import { useQuery } from '@tanstack/react-query';
import { expertTipApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertTipFilters } from '../types/expert-tip';

export function useExpertTips(filters: Partial<ExpertTipFilters>) {
  return useQuery({
    queryKey: queryKeys.expertTips.list(filters),
    queryFn: () => expertTipApi.listExpertTips(filters),
    placeholderData: (previousData) => previousData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
